import _defineProperty from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _statusUpdateTypeToTe, _statusUpdateTypeToDe;

export var workflowStatuses = {
  DRAFT: 'draft',
  ACTIVE: 'active',
  CLOSED: 'closed'
};
export var workflowTypes = {
  INVESTIGATING: 'investigating',
  ONBOARDING: 'onboarding'
};
export var workflowProducts = {
  SCORE: 'score',
  REPORT: 'report'
};
export var workflowPayment = {
  CLIENT: 'client',
  SUPPLIER: 'supplier',
  HYBRID: 'hybrid'
};
export var workflowReportTypes = {
  BIR: 'bir',
  RAC: 'rac',
  RAF: 'raf',
  SHORT_FORM: 'short_form',
  SHORT_FORM_PLUS: 'short_form_plus',
  SQR: 'sqr',
  CAR: 'car',
  QUESTIONNAIRE: 'questionnaire',
  HOM_9_ASPECTS: 'hom_9_aspects',
  HOM_8_ASPECTS: 'hom_8_aspects',
  HOM_7_ASPECTS: 'hom_7_aspects',
  HOM_FALLLABELLLA: 'hom_fallabella',
  HOM_FALLLABELLLA_MID: 'hom_fallabella_mid',
  CCR: 'ccr',
  CFR_LEV_1: 'cfr_lev_1',
  CFR_LEV_2: 'cfr_lev_2',
  CFR_LEV_3: 'cfr_lev_3',
  CFR: 'cfr'
};
export var supplierStatuses = {
  PENDING: 'pending',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  ARCHIVED: 'archived'
};
export var supplierStatusUpdateTypes = {
  EMAIL_RECEIVED: 'email_received',
  STARTED_ONBOARDING: 'started_onboarding',
  CIAL_ACCOUNT: 'cial_account',
  PAYMENT_REFERENCE: 'payment_reference',
  PAYMENT_PROOF: 'payment_proof',
  STARTED_FORM: 'started_form',
  ADDITIONAL_FILES: 'additional_files',
  STARTED_QUESTIONNAIRE: 'started_questionnaire',
  DATA_VERIFICATION: 'data_verification',
  SUPPLIER_UPDATE_DATA: 'supplier_update_data',
  CREATING_REPORT: 'creating_report',
  REPORT_CREATED: 'report_created',
  CREATING_SCORE: 'creating_score',
  SCORE_CREATED: 'score_created',
  ONBOARDING_COMPLETED: 'onboarding_completed'
};
export var statusUpdateTypeToText = (_statusUpdateTypeToTe = {}, _defineProperty(_statusUpdateTypeToTe, supplierStatusUpdateTypes.EMAIL_RECEIVED, 'Waiting on supplier'), _defineProperty(_statusUpdateTypeToTe, supplierStatusUpdateTypes.STARTED_ONBOARDING, 'Process initiated'), _defineProperty(_statusUpdateTypeToTe, supplierStatusUpdateTypes.CIAL_ACCOUNT, 'Account created'), _defineProperty(_statusUpdateTypeToTe, supplierStatusUpdateTypes.PAYMENT_REFERENCE, 'Pending payment'), _defineProperty(_statusUpdateTypeToTe, supplierStatusUpdateTypes.PAYMENT_PROOF, 'Payment successful'), _defineProperty(_statusUpdateTypeToTe, supplierStatusUpdateTypes.STARTED_FORM, 'Providing data'), _defineProperty(_statusUpdateTypeToTe, supplierStatusUpdateTypes.ADDITIONAL_FILES, 'Uploading files'), _defineProperty(_statusUpdateTypeToTe, supplierStatusUpdateTypes.STARTED_QUESTIONNAIRE, 'Filling questionnaire'), _defineProperty(_statusUpdateTypeToTe, supplierStatusUpdateTypes.DATA_VERIFICATION, 'Under analysis'), _defineProperty(_statusUpdateTypeToTe, supplierStatusUpdateTypes.SUPPLIER_UPDATE_DATA, 'Supplier updating data'), _defineProperty(_statusUpdateTypeToTe, supplierStatusUpdateTypes.CREATING_REPORT, 'Processing report'), _defineProperty(_statusUpdateTypeToTe, supplierStatusUpdateTypes.REPORT_CREATED, 'Report delivered'), _defineProperty(_statusUpdateTypeToTe, supplierStatusUpdateTypes.CREATING_SCORE, 'Processing score'), _defineProperty(_statusUpdateTypeToTe, supplierStatusUpdateTypes.SCORE_CREATED, 'Score delivered'), _defineProperty(_statusUpdateTypeToTe, supplierStatusUpdateTypes.ONBOARDING_COMPLETED, 'Onboarding completed'), _statusUpdateTypeToTe);
export var statusUpdateTypeToDescription = (_statusUpdateTypeToDe = {}, _defineProperty(_statusUpdateTypeToDe, supplierStatusUpdateTypes.EMAIL_RECEIVED, 'The client has launched the workflow but the supplier hasn\'t done any actions yet (or was bounced)'), _defineProperty(_statusUpdateTypeToDe, supplierStatusUpdateTypes.STARTED_ONBOARDING, 'The supplier has started the onboarding process'), _defineProperty(_statusUpdateTypeToDe, supplierStatusUpdateTypes.CIAL_ACCOUNT, 'The supplier has created a MyCIAL account'), _defineProperty(_statusUpdateTypeToDe, supplierStatusUpdateTypes.PAYMENT_REFERENCE, 'The supplier has created a payment reference but hasn\'t uploaded a payment proof yet'), _defineProperty(_statusUpdateTypeToDe, supplierStatusUpdateTypes.PAYMENT_PROOF, 'The supplier has uploaded the payment proof'), _defineProperty(_statusUpdateTypeToDe, supplierStatusUpdateTypes.STARTED_FORM, 'The supplier is filling the corresponding business form'), _defineProperty(_statusUpdateTypeToDe, supplierStatusUpdateTypes.ADDITIONAL_FILES, 'The supplier is uploading the files'), _defineProperty(_statusUpdateTypeToDe, supplierStatusUpdateTypes.STARTED_QUESTIONNAIRE, 'The supplier is filling the questionnaire requested by the client'), _defineProperty(_statusUpdateTypeToDe, supplierStatusUpdateTypes.DATA_VERIFICATION, 'CIAL is analysing the data from the supplier'), _defineProperty(_statusUpdateTypeToDe, supplierStatusUpdateTypes.SUPPLIER_UPDATE_DATA, 'The supplier needs to update data or documents as requested by CIAL analysis'), _defineProperty(_statusUpdateTypeToDe, supplierStatusUpdateTypes.CREATING_REPORT, 'CIAL is creating the business report'), _defineProperty(_statusUpdateTypeToDe, supplierStatusUpdateTypes.REPORT_CREATED, 'CIAL has delivered the report'), _defineProperty(_statusUpdateTypeToDe, supplierStatusUpdateTypes.CREATING_SCORE, 'CIAL is creating the score for the supplier'), _defineProperty(_statusUpdateTypeToDe, supplierStatusUpdateTypes.SCORE_CREATED, 'CIAL has delivered the score'), _defineProperty(_statusUpdateTypeToDe, supplierStatusUpdateTypes.ONBOARDING_COMPLETED, 'The supplier has finished the onboarding process'), _statusUpdateTypeToDe);
export var statusUpdateTypesOrder = [supplierStatusUpdateTypes.EMAIL_RECEIVED, supplierStatusUpdateTypes.STARTED_ONBOARDING, supplierStatusUpdateTypes.CIAL_ACCOUNT, supplierStatusUpdateTypes.PAYMENT_REFERENCE, supplierStatusUpdateTypes.PAYMENT_PROOF, supplierStatusUpdateTypes.STARTED_FORM, supplierStatusUpdateTypes.ADDITIONAL_FILES, supplierStatusUpdateTypes.STARTED_QUESTIONNAIRE, supplierStatusUpdateTypes.DATA_VERIFICATION, supplierStatusUpdateTypes.SUPPLIER_UPDATE_DATA, supplierStatusUpdateTypes.CREATING_SCORE, supplierStatusUpdateTypes.SCORE_CREATED, supplierStatusUpdateTypes.CREATING_REPORT, supplierStatusUpdateTypes.REPORT_CREATED, supplierStatusUpdateTypes.ONBOARDING_COMPLETED];
export var questionTypes = {
  INPUT: 'input',
  RADIO: 'radio',
  CHECKBOX: 'checkbox',
  FILE: 'file',
  SECTION: 'section',
  ATTACHMENT: 'attachment'
};
export var riskIndicators = {
  '1': 'Minimal risk',
  '2': 'Low risk',
  '3': 'Slightly greater than the average risk',
  '4': 'Meaningful risk',
  S: 'Risk not assigned due to business nature',
  '-': 'Unknown Risk'
};
export var racRiskIndicators = {
  '1': 'Minimum risk',
  '2': 'Low risk',
  '3': 'Medium risk',
  '4': 'Risk above average',
  '5': 'Significant risk',
  '6': 'High risk',
  '-': 'Unknown risk'
};
export var riskIndicatorsOrder = ['1', '2', '3', '4', 'S', '-'];
export var racRiskIndicatorsOrder = ['1', '2', '3', '4', '5', '6', '-'];
export var riskIndicatorsClasses = {
  '1': 'deep-green',
  '2': 'green',
  '3': 'yellow',
  '4': 'coral',
  'S': 'deep-blue',
  '-': 'light-grey'
};
export var racRiskIndicatorsClasses = {
  '1': 'deep-green',
  '2': 'green',
  '3': 'light-green',
  '4': 'yellow',
  '5': 'coral',
  '6': 'rosewood',
  '-': 'light-grey'
};
export var financialStrengthOrder = ['5A', '5AA', '4A', '4AA', '3A', '3AA', '2A', '2AA', '1A', '1AA', 'BA', 'A', 'AA', 'B', 'BB', 'CB', 'C', 'CC', 'DC', 'D', 'DD', 'E', 'EE', 'F', 'FF', 'G', 'GG', 'H', 'HH', '1R', '2R', 'ER1', 'ER2', 'ER3', 'ER4', 'ER5', 'ER6', 'ER7', 'ER8', 'ERN', 'NQ', 'NB', 'O', 'N', 'FB', 'BR', 'DS', 'INV', 'UTL', '-'];
export var financialStrengthClasses = {
  '5A': 'deep-blue',
  '5AA': 'deep-blue',
  '4A': 'mint',
  '4AA': 'mint',
  '3A': 'navy-blue',
  '3AA': 'navy-blue',
  '2A': 'sky-blue',
  '2AA': 'sky-blue',
  '1A': 'violet',
  '1AA': 'violet',
  'BA': 'purple',
  'A': 'purple',
  'AA': 'purple',
  'B': 'yellow',
  'BB': 'yellow',
  'CB': 'light-orange',
  'C': 'light-orange',
  'CC': 'light-orange',
  'DC': 'pink',
  'D': 'pink',
  'DD': 'pink',
  'E': 'deep-pink',
  'EE': 'deep-pink',
  'F': 'dark-orange',
  'FF': 'dark-orange',
  'G': 'coral',
  'GG': 'coral',
  'H': 'rosewood',
  'HH': 'rosewood',
  '1R': 'grey',
  '2R': 'grey',
  'ER1': 'grey',
  'ER2': 'grey',
  'ER3': 'grey',
  'ER4': 'grey',
  'ER5': 'grey',
  'ER6': 'grey',
  'ER7': 'grey',
  'ER8': 'grey',
  'ERN': 'grey',
  'NQ': 'grey',
  'NB': 'grey',
  'O': 'grey',
  'N': 'grey',
  'FB': 'grey',
  'BR': 'grey',
  'DS': 'grey',
  'INV': 'grey',
  'UTL': 'grey',
  '-': 'grey'
};